import { useEffect, useState } from 'react';
import { deployedVersionChanged, entryAsset } from '../lib/app-version';

/**
 * Do not silently reload during a draft, payment form or booking edit.
 * Recheck on focus/visibility + interval and offer a deliberate reload.
 * A tab running the *old* bundle still needs its first manual reload.
 */
export function AppVersionNotice() {
  const [available, setAvailable] = useState(false);
  useEffect(() => {
    const current = entryAsset(document, window.location.origin);
    if (!current) return;
    let stopped = false;
    let running = false;
    let found = false;
    const check = async () => {
      if (stopped || running || found || document.visibilityState === 'hidden') return;
      running = true;
      const controller = new AbortController();
      const abort = window.setTimeout(() => controller.abort(), 8000);
      try {
        if (await deployedVersionChanged(current, fetch, window.location.origin, controller.signal) && !stopped) {
          found = true;
          setAvailable(true);
        }
      } catch {
        // A network failure cannot log the user out or interfere with drafts.
      } finally {
        window.clearTimeout(abort);
        running = false;
      }
    };
    const first = window.setTimeout(() => void check(), 5000);
    const periodic = window.setInterval(() => void check(), 60000);
    const onFocus = () => { void check(); };
    const onVisible = () => { if (document.visibilityState === 'visible') void check(); };
    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      stopped = true;
      window.clearTimeout(first);
      window.clearInterval(periodic);
      window.removeEventListener('focus', onFocus);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);

  if (!available) return null;
  return <aside role="status" aria-live="polite" data-testid="jack-os-update-notice"
    className="fixed bottom-4 left-4 right-4 z-[90] mx-auto flex max-w-xl flex-wrap items-center justify-between gap-3 rounded-xl border border-line bg-surface p-4 text-sm text-ink shadow-lg">
    <span className="min-w-0 flex-1">Доступна новая версия Jack OS. Завершите ввод и обновите приложение.</span>
    <button type="button" className="min-h-11 shrink-0 rounded-lg bg-accent px-4 py-2 font-semibold text-white"
      onClick={() => window.location.reload()}>Обновить приложение</button>
  </aside>;
}
